export default "__VITE_ASSET__960127a0__"